import React from 'react';
import styled from 'styled-components';
import { media } from '../../utilities/style-utilities';

const EdenredHeader = styled.header`
  display: flex;
  justify-content: center;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgb(255, 255, 255)'};
  padding: 1rem;
  flex: 0 1 auto;
`;

const LogoImage = styled.img`
  max-width: 100%;
  height:auto;
  display: block;
  ${ media.mobile`
    max-height: 50px;
  `}
`;

const Header = (props) => {
  return (
    <EdenredHeader backgroundColor={props.header.backgroundColor} className={props.className}>
        
          <LogoImage src={props.header.logoSrc} alt={props.header.logoAlt} />
        
    </EdenredHeader>
  )
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js